import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroupConfigs from 'modules/surveys/store/collections/questionGroupConfigs'
import QuestionGroupConfig from 'modules/surveys/store/models/QuestionGroupConfig'

export function useQuestionGroupConfig(questionGroupConfigId: number) {
  const [questionGroupConfig, setQuestionGroupConfig] = React.useState(
    questionGroupConfigs.find({
      id: questionGroupConfigId,
    })
  )
  useAsyncData(async () => {
    if (questionGroupConfig) return

    const _questionGroupConfig = new QuestionGroupConfig({
      id: questionGroupConfigId,
    })

    await _questionGroupConfig.fetch()
    setQuestionGroupConfig(_questionGroupConfig)
  }, [])

  return {
    questionGroupConfig,
  }
}
